import type { AuthError } from '@azure/msal-browser-1p';
export type AuthStatus = 'None' | 'MsalAuthSuccess' | 'MsalAuthError';

let authStatus: AuthStatus = 'None';
let authError: string = '';
let fromCache: boolean | undefined;
let pageVisible: boolean | undefined;
let msalVersion: string = '';
let authErrorDetails:
    | {
          errorMessage: string;
          subError: string;
          correlationId: string;
      }
    | undefined;

export function setAuthStatusInfo(
    msalAuthStatus: AuthStatus,
    correlationId: string,
    version: string,
    error?: AuthError,
    cache?: boolean,
    pageAlwaysVisible?: boolean
): void {
    authStatus = msalAuthStatus;
    fromCache = cache;
    pageVisible = pageAlwaysVisible;
    msalVersion = version;
    if (error) {
        authError = error.errorCode;
        authErrorDetails = {
            errorMessage: error.errorMessage,
            subError: error.subError,
            correlationId,
        };
    }
}

export interface AuthStatusInfo {
    authStatus: AuthStatus;
    authError: string;
    fromCache: boolean | undefined;
    pageVisible: boolean | undefined;
    msalVersion: string;
    authErrorDetails?: {
        errorMessage: string;
        subError: string;
        correlationId: string;
    };
}

export function getAuthStatusInfo(): AuthStatusInfo {
    return { authStatus, authError, fromCache, pageVisible, msalVersion, authErrorDetails };
}
